import { toTimezone } from 'utils/dateTimeUtils';

class BaseFolder {
  constructor(params) {
    // validations
    if (!_.isPlainObject(params)) {
      return console.error(
        'TypeError: "params" should be a object for BaseFolder!'
      );
    }

    const {
      id = -1,
      name = '',
      createdOn = null,
      isSharedByOthers = false,
      sharedToUsers = [],
      sharedToTeams = [],
      data = []
    } = params;

    this.id = id;
    this.name = name;
    this.createdOn = this.parseTime(createdOn);
    this.isSharedByOthers = isSharedByOthers;
    this.sharedToUserIds = this.getSharedUserIds(sharedToUsers);
    this.sharedToTeamIds = this.getSharedTeamIds(sharedToTeams);
    this.data = data;
  }

  parseTime(val) {
    return toTimezone(val, true);
  }

  getSharedUserIds(data) {
    if (!_.isArray(data)) return [];
    return data.map(u => u.id);
  }

  getSharedTeamIds(data) {
    if (!_.isArray(data)) return [];
    return data.map(t => t.id);
  }
}

export default BaseFolder;



// WEBPACK FOOTER //
// ./src/models/Reports/BaseFolder.js